import { useEffect, memo, type ReactNode } from "react";
import { LoadingSkeleton } from "@narmi/design_system";
import { modules } from "byzantine";
import Container from "../../Container";

const InvoiceContainer = memo(({ children }: { children: ReactNode }) => {
  // call all the bootstrap request hooks, specifically `useFetchRecipients` which will populate the store with recipients
  const { loading, load } = modules.achPayments.bootstrap.useBootstrap();
  useEffect(() => {
    load();
  }, [load]);

  return (
    <LoadingSkeleton isLoading={loading}>
      <Container maxWidth="1200px">{children}</Container>
    </LoadingSkeleton>
  );
});

export default InvoiceContainer;
